import { UserInfo } from '../../../../../models/getUserInfo/GetUserInfo'

export default class UserInfoHelper {
  static Users: Array<UserInfo> = []
  static NotFoundUsers: Array<string | number> = []

  static getUser(userData: number | string): UserInfo | undefined {
    return this.Users.find((user) => {
      if (typeof userData === 'string') {
        if (user.value === userData) {
          return user
        }

        if (user.info.login?.includes(userData)) {
          return user
        }
      }

      if (typeof userData === 'number' && user.info.id === userData) {
        return user
      }
    })
  }
}
